import React from "react"
import Label from "components/Label"
import { useLocale } from "context/locale"
import StyledStrategyHeader from "./styles"

const StrategyHeader = () => {
  const { t } = useLocale()

  return (
    <StyledStrategyHeader>
      <Label text="#circularity" />
      <h2 className="title h1">{t("Our strategy")}</h2>
      <p className="desc">
        {t(
          "We start the change from ourselves. Following the Kaizen philosophy, we believe that small steps lead to the big change. „We act both inside the company as well as outside, by taking part in external environmental projects.”"
        )}
      </p>
    </StyledStrategyHeader>
  )
}

export default StrategyHeader
